import React, { Component, Fragment } from 'react'
//css
import '../css/inicio.css';
import '../css/politica-privacidad.css';
//componentes
import Nav from '../components/nav/Nav';
import Footer from '../components/footer/Footer';

class PoliticaPrivacidad extends Component {
    render() {
        return (
            <Fragment>
                <Nav />
                <div className="contenedorTitulo">
                    <p className="titulo">Política de Privacidad</p>
                </div>
                <div className="d-md-flex flex-md-equal w-100 my-md-3 pl-md-3">
                    <div className="contenedorTexto">
                            <p className="subtitulo">DECLARACIÓN DE PRIVACIDAD</p>
                            <p className="subtitulo">SECCIÓN 1 - ¿QUÉ HACEMOS CON TU INFORMACIÓN?</p>
                            <p className="parrafo">
                            Cuando compras algo mediante nuestra aplicación en uno de los negocios registrados, como parte del proceso de compra venta, nosotros recolectamos la información personal que nos das tales como nombre, dirección y correo electrónico.
                            </p>
                            <p className="parrafo">
                            Con tu permiso, podremos enviarte correos electrónicos acerca de nuestra aplicación, nuevos productos y otras actualizaciones.
                            </p>
                            <p className="subtitulo">SECCIÓN 2 - CONSENTIMIENTO</p>
                            <p className="parrafo">
                            ¿Cómo obtienen mi consentimiento? Cuando nos provees tu información personal al registrarte, crear una orden, implicamos que aceptas la recolección y uso por esa razón específica solamente.
                            </p>
                            <p className="parrafo">
                            Si te pedimos tu información personal por una razón secundaria, como marketing, te pediremos directamente tu expreso consentimiento, o te daremos la oportunidad de negarte.
                            </p>
                            <p className="parrafo">
                            ¿Cómo puedo anular mi consentimiento?
                            Si luego de haber aceptado cambias de opinión, puedes anular tu consentimiento para que te contactemos, por la recolección, uso o divulgación de tu información, en cualquier momento, contactándonos a CORREO REQUERIDO.
                            </p>
                            <p className="subtitulo">
                            SECCIÓN 3 - DIVULGACIÓN
                            </p>
                            <p className="parrafo">
                            Podemos divulgar tu información personal si se nos requiere por ley o si violas nuestros Términos de Servicio.
                            </p>
                            <p className="subtitulo">
                            SECCIÓN 4 – NOMBRE DE APP
                            </p>
                            <p className="parrafo">
                            Nuestra App se encuentra alojada en Play Store. Ellos nos proporcionan la plataforma mediante la cual las personas pueden descargar la aplicación y utilizarla como mejor le parezca. 
                            </p>
                            <p className="parrafo">
                            Tus datos se almacenan a través del almacenamiento de datos de Firebase. Tus datos se almacenan en un servidor seguro detrás de un firewall. 
                            </p>
                            <p className="subtitulo">
                            SECCIÓN 5 - SEGURIDAD
                            </p>
                            <p className="parrafo">
                            Para proteger tu información personal, tomamos precauciones razonables y seguimos las mejores prácticas de la industria para asegurarnos de que no haya pérdida de manera inapropiada, mal uso, acceso, divulgación, alteración o destrucción de la misma.
                            </p>
                            <p className="subtitulo">
                            SECCIÓN 6 - EDAD DE CONSENTIMIENTO
                            </p>
                            <p className="parrafo">
                            Al utilizar esta aplicación, declaras que tienes al menos la mayoría de edad en tu estado o provincia de residencia, o que tienes la mayoría de edad en tu estado o provincia de residencia y que nos has dado tu consentimiento para permitir que cualquiera de tus dependientes menores use esta app.
                            </p>
                            <p className="subtitulo">
                            SECCIÓN 7 - CAMBIOS A ESTA POLÍTICA DE PRIVACIDAD
                            </p>
                            <p className="parrafo">
                            Nos reservamos el derecho de modificar esta política de privacidad en cualquier momento, asi que por favor revísala frecuentemente.  Cambios y aclaraciones entrarán en vigencia inmediatamente después de su publicación en el sitio web.  Si hacemos cambios materiales a esta política, notificaremos aquí que ha sido actualizada, por lo cual estás enterado de qué información recopilamos, cómo y bajo qué circunstancias, si las hubiere, la utilizamos y/o divulgamos.
                            </p>
                            <p className="subtitulo">
                            PREGUNTAS E INFORMACIÓN DE CONTACTO
                            </p>
                            <p className="parrafo">
                            Si quieres: acceder, corregir, enmendar o borrar cualquier información personal que poseamos sobre ti, registrar una queja, o simplemente quieres más información contacta a nuestro Encargado de Cumplimiento de Privacidad CORREO REQUERIDO o mediante nuestras redes sociales <a href='#' target="_blank">PAGINA FACEBOOK</a>.
                            </p>
                            <p className="parrafo">
                            [Re: Privacy Compliance Officer]
                            [DIRECCION ]
                            </p>
                    </div>
                </div>
                <Footer />
            </Fragment>
        )
    }
}

export default PoliticaPrivacidad;